import { faRulerTriangle } from '@fortawesome/pro-light-svg-icons'
import {
  ResidentialApartmentPropertyDetails,
  ResidentialHousePropertyDetails,
  ResidentialType,
} from '@unreserved-frontend-v2/api/generated/graphql/types'
import { DetailsTableRow } from '@unreserved-frontend-v2/ui/details-table/models'
import { emptyDefault } from '@unreserved-frontend-v2/utils/empty-default'
import useTranslation from 'next-translate/useTranslation'
import { useMemo } from 'react'
import { lotDimensions } from '../../../../utils/formatters/lot-dimensions'

export const useLotRow = (
  details?: ResidentialApartmentPropertyDetails | ResidentialHousePropertyDetails | null
): DetailsTableRow | undefined => {
  const { t } = useTranslation()
  return useMemo(() => {
    if (details?.residentialType !== ResidentialType.House) {
      return
    }
    const house = details as ResidentialHousePropertyDetails
    const dimensionsValue = lotDimensions(house.lot)

    if (!dimensionsValue && !house.lot?.acres) {
      return
    }

    return {
      icon: faRulerTriangle,
      title: t('listings:details-pages.lot'),
      cells: [
        {
          id: 'lot',
          data: [
            {
              id: 'data-lot-size',
              label: t('listings:details-pages.size'),
              value: emptyDefault(dimensionsValue),
            },
          ],
        },
        {
          id: 'lot-2',
          data: [
            {
              id: 'data-acres',
              label: t('listings:details-pages.acres'),
              value: emptyDefault(house.lot?.acres),
            },
          ],
        },
      ],
    }
  }, [details, t])
}
